module.exports = __webpack_public_path__ + "sms_70x70.30e2a05096c1192ff1f96cf11acfdf17.png";